import { getObjectUtil } from 'packages/src'

/**
 * Gets the status of a instance.
 * @param  {Instance} instance
 * @returns {Status|null}
 */
function getStatusReduxUtil (instance) {
  return getObjectUtil(instance, 'status')
}

export {
  getStatusReduxUtil
}
